/* PDP gallery: 5-view crossfade + thumbnail strip. Per phase-06's state
 * machine, "click is the contract" (works with JS disabled via the anchor
 * fallback below is out of scope — the thumbs are real <button>s, so at
 * minimum they are keyboard-focusable and their click still runs this
 * handler); mouseenter-switch is a desktop-only nicety layered on top.
 *
 * Panes are absolutely stacked and cross-fade via an `is-active` class
 * (opacity transition lives in afroyla-pdp.css); default view is index 0. */
(function () {
  'use strict';

  function init(gallery) {
    if (gallery.__init) return;
    gallery.__init = true;

    var panes = gallery.querySelectorAll('[data-pdp-view]');
    var thumbs = gallery.querySelectorAll('[data-pdp-thumb]');

    function show(index) {
      panes.forEach(function (pane) {
        pane.classList.toggle('is-active', pane.getAttribute('data-pdp-view') === String(index));
      });
      thumbs.forEach(function (thumb) {
        var active = thumb.getAttribute('data-pdp-thumb') === String(index);
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    /* Variant -> gallery sync (06.10): a variant with its own image (the A-Z
     * letter charms) jumps the stage to that image when its swatch is tapped.
     * Listens on the section so it catches afroyla-material-cards.js's
     * theme:variant:change; no-op when the variant has no featured media. */
    var section = gallery.closest('.shopify-section') || document;
    section.addEventListener('theme:variant:change', function (event) {
      var variant = event.detail && event.detail.variant;
      var mediaId = variant && variant.featured_media && variant.featured_media.id;
      if (!mediaId) return;
      var pane = gallery.querySelector('[data-pdp-view][data-media-id="' + mediaId + '"]');
      if (pane) show(pane.getAttribute('data-pdp-view'));
    });

    thumbs.forEach(function (thumb) {
      var index = thumb.getAttribute('data-pdp-thumb');
      thumb.addEventListener('click', function () {
        show(index);
      });
      thumb.addEventListener('mouseenter', function () {
        if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) show(index);
      });
    });
  }

  function adoptAll(root) {
    (root || document).querySelectorAll('[data-pdp-gallery]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { adoptAll(document); });
  } else {
    adoptAll(document);
  }

  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches && node.matches('[data-pdp-gallery]')) init(node);
          else if (node.querySelector && node.querySelector('[data-pdp-gallery]')) adoptAll(node);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
